import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskAccountNumber',
})
export class MaskAccountNumberPipe implements PipeTransform {
  transform(value: string | undefined | null): string {
    if (value != null || value != undefined) return `**${value.slice(-4)}`;
    return '';
  }
}
